import { Instagram } from "lucide-react";
import { LOGO, INSTAGRAM, INSTAGRAM_HANDLE, BOOK_ALL } from "../data";

const LINKS = [
  { label: "Gallery", href: "#gallery" },
  { label: "Services", href: "#services" },
  { label: "Hours", href: "#hours" },
  { label: "Book Now", href: BOOK_ALL },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-black border-t border-white/10 pb-24 md:pb-12 pt-14">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-3 gap-10 items-start">
      <div className="flex items-center gap-3">
        <img src={LOGO} alt="AK Cuts" className="h-12 w-12 object-contain" />
        <span className="font-display text-2xl tracking-wider text-cream">AK CUTS</span>
      </div>

      <div className="flex flex-col gap-3">
        {LINKS.map((l) => (
          <a key={l.label} href={l.href}
            className="font-mono-u text-xs tracking-widest uppercase text-cream/60 hover:text-barber-red transition-colors w-fit">
            {l.label}
          </a>
        ))}
      </div>

      <div>
        <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
          className="inline-flex items-center gap-2 text-cream/80 hover:text-barber-red transition-colors">
          <Instagram size={20} />
          <span className="font-mono-u text-sm">{INSTAGRAM_HANDLE}</span>
        </a>
      </div>
    </div>

    <div className="max-w-6xl mx-auto px-4 sm:px-6 mt-12 pt-6 border-t border-white/10">
      <p className="font-mono-u text-[11px] tracking-wider text-cream/40">
        © 2026 AK Cuts — Aaheeka The Barber. Pakenham, VIC.
      </p>
    </div>
  </footer>
);
